import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs, P } from '../../../AbstractElements';
import DeleteData from './DeleteData'

const DataDelete = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Delete Data" title="Delete Data" mainTitle="Delete Data" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <DeleteData />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default DataDelete